import { useEffect, useLayoutEffect, useRef } from "react";

// F7's ListInput forwards neither enterkeyhint nor onKeyDown to its <input>.
export const useEnterKeys = (containerId, inputsByName) => {
  const latest = useRef(inputsByName);
  latest.current = inputsByName;

  useLayoutEffect(() => {
    const container = document.getElementById(containerId);
    if (!container) return;
    Object.entries(inputsByName).forEach(([name, { hint }]) => {
      container
        .querySelectorAll(`[name="${name}"]`)
        .forEach((input) => input.setAttribute("enterkeyhint", hint));
    });
  });

  useEffect(() => {
    const container = document.getElementById(containerId);
    if (!container) return undefined;
    const handleKeyDown = (event) => {
      const input = latest.current[event.target.name];
      if (event.key !== "Enter" || !input) return;
      if (input.next) {
        event.preventDefault();
        container.querySelector(`[name="${input.next}"]`)?.focus();
      } else if (input.hint === "done") {
        event.preventDefault();
        event.target.blur();
      }
    };
    container.addEventListener("keydown", handleKeyDown);
    return () => container.removeEventListener("keydown", handleKeyDown);
  }, [containerId]);
};
